import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import {
  formatPremiumValue,
  formatPremiumWithCurrency,
} from "../../../utils/index";
import Button from "../../common/Button/Button";

const BottomStickyBtnLayout = ({
  children,
  btn_label,
  btn_onClick,
  btn_disabled,
  show_summary = false,
  price,
  onShowSummary,
  AdditionalComponent,
  hideContinueBtn = false,
  addonComponent,
  isLoading = false,
  btn_text,
}) => {
  const { t, i18n } = useTranslation();
  const translate = useLanguageTranslate();

  // Resolve the stable portal target rendered by NewPersonalCyberPolicy.
  // Falls back to inline rendering when used outside that flow.
  const [portalTarget, setPortalTarget] = useState(null);
  useEffect(() => {
    if (typeof document === "undefined") return;
    setPortalTarget(document.getElementById("pc-footer-portal"));
  }, []);

  // Helper function for footer currency formatting with English numerals
  const formatFooterCurrency = (amount) => {
    if (i18n.resolvedLanguage === "ar") {
      // Arabic: use English numerals and reverse order (amount currency)
      return `${formatPremiumValue(amount, "en-US", 3)} د.ب`;
    } else {
      // English: standard format (currency amount)
      return formatPremiumWithCurrency(amount, "BHD", "en-US");
    }
  };

  const footer = (
      <div className="footer items-center bg-white border-t border-[#E5E9EB] w-full py-2 flex justify-end fixed pr-10 bottom-0 max767:w-full max767:px-4 max767:pt-3 max767:pb-[max(2.25rem,calc(env(safe-area-inset-bottom)+1rem))] max767:inset-x-0 ipad:items-center max767:inline-block max767:z-[9] left-0">
        {addonComponent && addonComponent}
        {show_summary && (
          <div className="mr-10 max767:w-full max767:flex max767:mb-2 max767:justify-between ipad:mt-0 rtl:ml-10 rtl:mr-0">
            <button
              onClick={onShowSummary}
              className="text-[#00384D] text-center text-base not-italic font-semibold underline mr-10 rtl:ml-10 rtl:mr-0"
            >
              {translate("Show Summary", "عرض التسعيرة")}
            </button>
            {price > 0 && (
              <strong className="text-[#1A2024] text-xl font-extrabold">
                {formatFooterCurrency(price)}
              </strong>
            )}
          </div>
        )}
        <div className="flex justify-end pr-0 rtl:pl-[3%] max767:w-full max767:pr-[0%]">
          <div className="flex max767:w-full max767:flex-col max767:gap-2">
            {AdditionalComponent && AdditionalComponent}
            {!hideContinueBtn && (
              <Button
                isLoading={isLoading}
                disabled={btn_disabled}
                onSubmit={btn_onClick ? btn_onClick : () => {}}
                type="submit"
                label={
                  btn_label ||
                  btn_text ||
                  t(
                    "motorInsurance.newMotorInsuranceFlow.basicInfo.continueButton"
                  )
                }
                className="mb-0 stickybutton flex w-[200px] flex-col items-center gap-2.5 shrink-0 p-4 bg-[#55C6EF] rounded-[10px] text-[#1A2024] text-center text-lg not-italic font-semibold leading-6 tracking-[-0.18px] max767:w-full max767:h-[48px] max767:py-3"
              />
            )}
          </div>
        </div>
      </div>
  );

  return (
    <>
      {children}
      {portalTarget ? createPortal(footer, portalTarget) : footer}
    </>
  );
};

export default BottomStickyBtnLayout;
